import React, {useState, useEffect, useCallback} from 'react'
import {Spinner} from '@material-tailwind/react'
import { debounce } from 'lodash';
import toast, { Toaster } from 'react-hot-toast';
import { v4 as uuidv4 } from 'uuid';
import { useSelector, useDispatch } from 'react-redux';
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon, ArrowPathIcon } from '@heroicons/react/24/solid';

import { encodedAddressPrefix, tippingAddress, ownerAddress, royalty, tip, contentLength, serviceFeeRate, padding, clockInFee } from '../../configs/constant';
import { Input } from '@material-tailwind/react'
import { formatAddress } from '../../util/format-data'
import { registerRunesPayment, latestTokenNew, checkWhiteListedAddress, registerTokenNew, getPaymentTx, getPaymentUtxosRunes, getPaymentHistoryNew, savePaymentHistoryNew, getSignMintTextNew, getMintStatus, checkWhiteListedDomain } from '../../util/new-api'
import { getAsciiSum } from '../../util/format-data';
import { getFeeRate, bytesToHex, buf2hex, textToHex, hexToBytes, getMempoolUtxos, waitSomeSeconds, pushBTCpmt } from '../../util/inscribe-util';
import FeeRateCard from '../../components/FeeRateCard';
import { BitcoinNetworkType, signMessage, signTransaction, sendBtcTransaction } from 'sats-connect';
import { latestDmtTokenRandom, latestTokenRandom, checkRuneName } from '../../util/new-api';
import {mintAlkanesStart, mintAlkanesCancel, mintAlkanesPrepare, mintAlkanesFunded, getPaymentUtxosForClockIn} from '../../util/alkanes-api';
import RuneTopIndexer from '../../components/Rune/RuneTopIndexer';
import { postUnisatTransaction } from '../../util/api';
import { broadcastBitcoinTransaction } from '../../util/new-api';
import alkanesImg from '../../assets/imgs/alkanes.png';
import cheekyImg from '../../assets/imgs/cheeky.png';
import { isValidTaprootAddress } from '../../util/inscribe-util';
import { registerReferalCode, registerReferalHistory, getReferalHistory, referalCodeCheck, getReferalParentAddress } from '../../util/refer-api.js'
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { formatNumberWithCommas } from '../../util/format-data';
import { BarsArrowDownIcon } from '@heroicons/react/24/solid';
import './style.css';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter
} from "@material-tailwind/react";

import { useWallet, useWallets } from '@wallet-standard/react';
import { savePointData } from '../../util/api';
import { useTranslation } from 'react-i18next';
import AlkanesTopIndexer from '../../components/Rune/AlkanesTopIndexer';
import { getAlkanesTopMint } from '../../util/alkanes-api';
import { getAlkanesKey } from '../../util/alkanes-api';
import { useParams } from 'react-router-dom';
import ReferalCard from '../../components/ReferalCard.js';
import { useNavigate } from 'react-router-dom';

import cheekyGif from '../../assets/imgs/cheeky.gif'
import referImg from '../../assets/imgs/referal.png'
import leaderboardImg from '../../assets/imgs/leaderboard2.png'
import clockinImg from '../../assets/imgs/ClockInTime.png'
import { getMempoolBlock } from '../../util/mempool-api';
import Dropdown from '../../components/Dropdown';
import { postClockInPayment, updateClockInTxId, bumpClockInPayment, getClockInPayment, getPaymentUtxosForClockInForReserve } from '../../util/alkanes-api';

export default function ClockInSystemReserve() {
  const { param } = useParams();
  const { wallets } = useWallets();
  const navigate = useNavigate();

  const SatsConnectNamespace = 'sats-connect:';

  const prices = useSelector(state => state.price);
  const feeRates = useSelector(state => state.feeRate);

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const { t, i18n } = useTranslation();
  const wallet = useSelector(state => state.wallet);

  const { Address, Script, Signer, Tap, Tx } = window.tapscript;
  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(0);
  const [feeValues, setFeeValues] = useState({
    "inscribeFee": 0,
    "networkFee": 0,
    "serviceFee": 0,
    "referFee": 0,
    "totalFee": 0
  });
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [domain, setDomain] = useState('');
  const [amount, setAmount] = useState(1);
  const [maximum, setMaximum] = useState(10000);
  const [sum, setSum] = useState(0);
  const [deployLimit, setDeployLimit] = useState(10000);
  const [address, setAddress] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [key, setKey] = useState('');
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);
  const [show, setShow] = useState(false);
  const [runeId, setRuneId] = useState("2:21568");
  const [inscriptionStatus, setInscriptionStatus] = useState(false);
  const [isRoyalty, setIsRoyalty] = useState(1);
  const [totalFees, setTotalFees] = useState(0);
  const [runeName, setRuneName] = useState('');
  const [codeIsValid, setCodeIsValid] = useState(false);
  const [referalAddress, setReferalAddress] = useState('');
  const [showReferalCard, setShowReferalCard] = useState(false);
  const [mempoolBlock, setMempoolBlock] = useState(0);
  const [remainingTime, setRemainingTime] = useState(0);
  const [remainingBlock, setRemainingBlock] = useState(0);
  const [dropDownItems, setDropDownItems] = useState([]);
  const [activeDropDown, setActiveDropDown] = useState(0);
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  const [boostFeeRate, setBoostFeeRate] = useState(0);
  const [currentBlock, setCurrentBlock] = useState(0);
  const [clockinReserveHistory, setClockInReserveHistory] = useState([]);
  const [showBoostFeeRate, setShowBoostFeeRate] = useState(false);
  const [maxBoostFeeRate, setMaxBoostFeeRate] = useState(0);
  const [boostData, setBoostData] = useState({});

  useEffect(() => {
    let intervalId;
    const updateMempoolBlock = async () => {
      const blockData = await getMempoolBlock();
      let currentBlockHeight = blockData[0].height;
      let tempBlock = Math.ceil((currentBlockHeight - 898421) / 144) * 144 + 898421;
      setMempoolBlock(tempBlock);
      setCurrentBlock(currentBlockHeight);
      setRemainingBlock(tempBlock - currentBlockHeight);
      setRemainingTime((tempBlock - currentBlockHeight) * 10);
    }
    updateMempoolBlock();
    intervalId = setInterval(updateMempoolBlock, 50 * 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, []);

  useEffect(() => {
    let startBlock = mempoolBlock - 1;
    if (remainingBlock < 3) startBlock = mempoolBlock + 144;

    let tempItems = [];
    tempItems.push(startBlock);
    for(let i = 0; i< 25; i++) {
      tempItems.push(startBlock + (i + 1) * 144);
    }
    setDropDownItems(tempItems);
    setActiveDropDown(tempItems[0]);
  }, [remainingBlock])

  useEffect(() => {
    let intervalId;

    const updateFees = async () => {
      try {
        if (feeRateMode == "Custom") {
          setFeerate(customFee);
        }
        else
        {
          setFeerate(feeRates[feeRateMode]);
          if (customFee == 0) 
          {
            setCustomFee(feeRates["Fast"] + 1);
          }
        }
      }
      catch (e) {
        console.log(e);
      }
    }
    updateFees();
    intervalId = setInterval(updateFees, 30 * 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, [feeRateMode, customFee])

  useEffect(() => {
    let tempFeerate = parseFloat(feerate);
    let tempBoostFeerate = parseFloat(boostFeeRate);

    if (isNaN(tempFeerate)) {
      tempFeerate = 1.1;
    }

    if (isNaN(tempBoostFeerate)) {
      tempBoostFeerate = 1.1;
    }

    if (tempFeerate < 1) {
      tempFeerate = 1.1;
    }

    if (tempBoostFeerate > tempFeerate && tempBoostFeerate < 1 + tempFeerate) {
      tempBoostFeerate = tempFeerate +  1;
    }

    if (tempBoostFeerate < tempFeerate) {
      tempBoostFeerate = tempFeerate;
    }

    let fees = calculateFee(tempBoostFeerate) + 546;

    setTotalFees(fees + clockInFee);

  }, [feerate, boostFeeRate])

  useEffect(() => {
    fetchClockInPaymentHistory();
  }, [wallet.nostrPaymentAddress, currentBlock])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  useEffect(() => { 
    setAddress(wallet.nostrOrdinalsAddress);
    // handleCheckRoyalty(wallet.nostrOrdinalsAddress);
  }, [wallet.nostrOrdinalsAddress]);

  const fetchClockInPaymentHistory = async () => {
    setLoading(true);
    if (wallet.nostrPaymentAddress == "") {
      setClockInReserveHistory([]);
    }
    else {
      let tempResults = await getClockInPayment(wallet.nostrPaymentAddress, currentBlock - 2);
      setClockInReserveHistory(tempResults);
    }
    setLoading(false);
  }

  const calculateFee = (feerate) => {
    let fee = Math.ceil((10 + 43.5 + 67.5 + 30) * feerate);
    return fee;
  }

  const handleReserve = async () => {
    setLoading(true);

    if (wallet.nostrOrdinalsAddress == "")
    {
      toast.error(t('Connect Wallet Error Message'));
      setLoading(false);
      return;
    }

    if (address == "") {
      toast.error(t('Please insert receiver address'));
      setLoading(false);
      return;
    }

    if (activeDropDown < currentBlock) {
      toast.error(t('Please select reserve block number'));
      setLoading(false);
      return;
    }

    let tempFeerate = parseFloat(feerate);
    let tempBoostFeerate = parseFloat(boostFeeRate);

    if (isNaN(tempFeerate)) {
      toast.error(t('Please select correct fee rate'));
      setLoading(false);
      return;
    }

    if (isNaN(tempBoostFeerate)) {
      toast.error(t('Please select correct boost fee rate'));
      setLoading(false);
      return;
    }

    if (tempFeerate < 1) {
      tempFeerate = 1.1;
    }

    if (tempBoostFeerate > tempFeerate && tempBoostFeerate < 1 + tempFeerate) {
      tempBoostFeerate = tempFeerate +  1;
    }

    if (tempBoostFeerate < tempFeerate) {
      tempBoostFeerate = tempFeerate;
    }

    let fees = calculateFee(tempBoostFeerate) + 546;

    let params = {
      receiveAddress: address,
      paymentAddress: wallet.nostrPaymentAddress,
      feerate: tempFeerate,
      boostFeerate: tempBoostFeerate,
      fees : fees,
      block : activeDropDown
    }

    let clockInResult = await postClockInPayment(params);
    if (clockInResult.status == "fail") {
      toast.error(t("Already Reserved for this address and block number"));
      setLoading(false);
      return;
    }

    let paramUtxos = {
      paymentAddress: wallet.nostrPaymentAddress, 
      fundingAddress: tippingAddress, 
      fundingAmount: clockInFee, 
      paymentPubkey: wallet.paymentPublicKey, 
      feeRate: tempFeerate, 
      provider: wallet.domain, 
      serviceAddress: clockInResult.address,
      serviceAmount: fees
    }
    const paymentUtxos = await getPaymentUtxosForClockInForReserve(paramUtxos);
    let txid = "";
    let isSuccess = true;

    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      isSuccess = false;
      return;
    }

    try{
      if (wallet.domain == "oyl") {
        txid = await window.oyl.signPsbt({ 
          psbt: paymentUtxos.hex,  
          broadcast: true
        })

        if (txid?.txid.length == 64) {
          txid = txid.txid;
        }
      }
      else if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
              await updateClockInTxId({id: clockInResult.id, txId: response.txId, hashKey: clockInResult.hashKey});
              fetchClockInPaymentHistory();
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          isSuccess = false;
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {   
              await updateClockInTxId({id: clockInResult.id, txId: response.txId, hashKey: clockInResult.hashKey});
              fetchClockInPaymentHistory();
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setShow(false);
          isSuccess = false;
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      return;
    }

    if (isSuccess) {
      if (txid != "") {
        await updateClockInTxId({id: clockInResult.id, txId: txid, hashKey: clockInResult.hashKey});
        fetchClockInPaymentHistory();
      }
    }

    setLoading(false);
  }

  const debouncedSearch = useCallback(debounce( async (value) => {
    try {
      let tempParams = {
        query: value,
        page: 1,
        limit: 10,
        order: "idAsc",
        active: null
      }
  
      let tempResults = await getAlkanesTopMint(tempParams);
      if (tempResults.data.total > 0 && tempResults.data.records[0].id == value) {
        setRuneName(tempResults.data.records[0].name);
      }
      else {
        setRuneName("");
      }
    }
    catch (e) {
      console.log(e);
    }
  }, 500), []); 

  const handleCustomFee = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setCustomFee(sanitizedValue);
  }

  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const toggleDropdown = () => {
    setDropdownIsOpen(!dropdownIsOpen);
  }

  const handleClickItem = (value) => {
    setActiveDropDown(value);
    setDropdownIsOpen(false);
  }

  const handleBoost = async (data) => {
    setShowBoostFeeRate(false);
    let customBoostFeerate = parseFloat(boostFeeRate);
    if (isNaN(customBoostFeerate)) {
      setBoostFeeRate("");
      toast.error(t('Please input correct boost fee rate'));
      return;
    }

    if (customBoostFeerate < data.feerate) {
      return;
    }

    try {
      await bumpClockInPayment({id: data.id, boostFeerate: parseFloat(customBoostFeerate)});
      fetchClockInPaymentHistory();
    }
    catch(e) {
      console.log(e);
    }
    setBoostFeeRate("");
  }

  return (
    <div className="text-white mt-[65px] w-full max-w-[1500px] md:px-7 px-2 flex flex-col justify-center items-center mb-10 min-h-[600px]">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed" color="pink"/> : <></>
      }
      <div className="text-2xl font-bold text-white bg-primary rounded-md px-4 py-2 mt-8">ClockInSystem ({t('Automated')})</div>
      <img src={clockinImg} className="sm:w-[120px] sm:h-[120px] w-[100px] h-[100px] md:mt-10 mt-6 mb-2"/>
      <div className="text-lg">Next clock-in block <span className="text-primary font-bold text-2xl">{formatNumberWithCommas(mempoolBlock)}</span> in {remainingTime > 60 ? Math.floor(remainingTime / 60) + " hours" : remainingTime + " minutes"} ({formatNumberWithCommas(remainingBlock)} blocks remaining)</div>
      <div className="flex xl:flex-row flex-col xl:gap-10 gap-3 items-start ">
        <div className="md:min-w-[500px] md:w-[600px] min-w-[300px] flex flex-col gap-2 md:mt-[55px] mt-8 w-full">
          <div className="border-gray-800 border-[1px] border-solid sm:p-8 p-5 rounded-lg flex flex-col md:gap-8 gap-4 bg-background3 md:w-[600px] w-full">
            <div>
              <Input type="text" color="white" label = {t('Receiver Address')} className="w-full md:min-w-[400px] min-w-[250px]" value={address} onChange = {(e) => {setAddress(e.target.value)}}/>
            </div>
            <div className="flex md:flex-row flex-col md:justify-between md:items-center justify-start gap-2 w-full">
              <div className="sm:text-[18px] text-[14px]">
                {t('Select block cycle to automate')}:
              </div>
              <div className="md:w-[200px] w-full dropdown">
                <div className="w-full dropdown-button-clockin" onClick={toggleDropdown}>
                  <div className="text-primary">{activeDropDown}</div>
                  <BarsArrowDownIcon strokeWidth={2} className="h-5 w-5 text-primary" />
                </div>
                {dropdownIsOpen && (
                  <div className="md:w-[200px] w-full dropdown-content-clockin overflow-y-auto max-h-[330px]">
                    {
                      dropDownItems.map((data) => {
                        return <a key={uuidv4()} href="#" onClick = {() => {handleClickItem(data)}}> {data}</a>
                      })
                    }
                  </div>
                )}
              </div>
            </div>
            <div className="sm:text-[18px] text-[14px]">
              {t('Select fee rate')}:
            </div>
            <div className="grid grid-cols-3 gap-3">
              <FeeRateCard header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
              <FeeRateCard header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
              <FeeRateCard header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
            </div>
            {
              feeRateMode == "Custom" ? 
              <div className="flex flex-row gap-3 items-center">
                <Slider className="sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
                <div className="sm:max-w-[200px] w-full">
                  <Input type="text" color="white" label = {t('Custom Fee')} className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
                </div>
              </div>
              : 
              <></>
            }

            <div className="flex flex-col gap-2">
              <div className="sm:text-[18px] text-[14px]">
                {t('Boost fee rate (optional)')}:
              </div>
              <div>
                <Input type="text" color="white" label = {t('Boost Fee Rate')} className="w-full md:min-w-[400px] min-w-[250px]" value={boostFeeRate} onChange = {(e) => {setBoostFeeRate(e.target.value)}}/>
              </div>
            </div>
            

            {/* <div className="m-auto md:w-[400px] w-full">
              <div className="flex flex-col mt-1 sm:text-[16px] text-[14px]">
                <div className="flex flex-row justify-between gap-1">
                  <div>{t('Inscribe Fee')}</div>
                  <div>{totalFees.inscribeFee / Math.pow(10, 8)} BTC (${(prices.bitcoin * parseInt(totalFees.inscribeFee) / Math.pow(10, 8)).toFixed(2)})</div>
                </div>
                <div className="flex flex-row justify-between gap-1">
                  <div>{t('Network Fee')}</div>
                  <div>{totalFees.networkFee / Math.pow(10, 8)} BTC (${(prices.bitcoin * parseInt(totalFees.networkFee) / Math.pow(10, 8)).toFixed(2)})</div>
                </div>
                <div className="flex flex-row justify-between gap-1">
                  <div>{t('Service Fee')}</div>
                  <div>{(parseInt(totalFees.serviceFee) + parseInt(totalFees.referFee)) / Math.pow(10, 8)} BTC (${(prices.bitcoin * (parseInt(totalFees.serviceFee) + parseInt(totalFees.referFee)) / Math.pow(10, 8)).toFixed(2)})</div>
                </div>

                <div className="w-full border-t-[1px] border-gray-800 my-1"></div>
                <div className="flex flex-row justify-between gap-1">
                  <div>{t('Total Fee')}</div>
                  <div>{totalFees.totalFee / Math.pow(10, 8)} BTC (${(prices.bitcoin * parseInt(totalFees.totalFee) / Math.pow(10, 8)).toFixed(2)})</div>
                </div>
              </div> 
            </div> */}
            <div className="flex flex-row justify-between items-center sm:text-[16px] text-[14px]">  
              <div>{t('You Pay')}</div>
              <div>{totalFees / Math.pow(10, 8)} BTC (${(prices.bitcoin * parseInt(totalFees) / Math.pow(10, 8)).toFixed(2)})</div>
            </div>
            <div className="text-red-500 text-[16px]">
              <div className="flex">
                <InformationCircleIcon className="h-6 w-6 text-red-500 mr-1" strokeWidth={2} />
                <span>{t('ClockInTime Info')}</span>
              </div>
            </div>
            <div className="flex flex-row w-full justify-center">
              <button className="bg-primary hover:bg-primary-hover rounded-md py-2 min-w-[240px]" onClick={handleReserve}>{t('Reserve')}</button>
            </div>
          </div>
        </div>
        {
          clockinReserveHistory.length > 0 ? 
          <div className="md:min-w-[500px] md:w-[600px] min-w-[300px] flex flex-col gap-2 md:mt-[55px] mt-8 w-full items-center">
            <div className="border-gray-800 border-[1px] border-solid sm:p-3 p-3 rounded-lg flex flex-col md:gap-8 gap-4 md:w-[600px] w-full items-center">
              <div className="w-full flex flex-row justify-between items-center">
                <div className="text-2xl text-primary font-bold mt-2">{t('Reserve History')}</div>
                <Tooltip content={t('Refresh')}>
                  <div className="cursor-pointer" onClick={() => fetchClockInPaymentHistory()}><ArrowPathIcon strokeWidth={2} className="h-5 w-5" /></div>
                </Tooltip>
              </div>
              {
                clockinReserveHistory.length > 0 ? 
                <div className="flex flex-col gap-2 w-full">
                  {
                    clockinReserveHistory.map((data) => {
                      return (
                        <div key={uuidv4()} className="flex flex-row p-2 bg-background2 rounded-md w-full items-center">
                          <div className="md:w-[25%] w-[40%] flex flex-row gap-2 items-center">
                            <div className="flex flex-col gap-1">
                              <span>{formatAddress(data.receiveAddress)}</span>
                              <span className="md:hidden flex">{data.block}</span>
                            </div>
                            {
                              data.txId ?
                              <svg onClick = {() => window.open(`https://mempool.space/tx/${data.txId}`, "_blank")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" className="tw-opacity-60 cursor-pointer" color="rgb(var(--textColor-primary))" width="18" height="18" size="18"><path d="M13.5 6.5L13.4994 2.50062L9.5 2.5M8.5 7.5L13.5 2.5M11.5 8.5V13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V5C2.5 4.86739 2.55268 4.74021 2.64645 4.64645C2.74021 4.55268 2.86739 4.5 3 4.5H7.5" stroke="currentColor" strokeLinecap="round" stroke-linejoin="round"></path></svg>
                              :
                              <></>
                            }
                          </div>
                          <div className="md:w-[18%] md:flex hidden">{data.block}</div>
                          <div className="md:w-[20%] md:flex hidden">{data.status == 4 ? data.boostFeerate : data.feerate} sats/vB</div>
                          <div className={`md:w-[19%] w-[30%] ${data.status == 2 ? "text-green-500" : "text-red-500"}`}>{data.status == 2 ? "Reserved" : "Broadcasted"}</div>
                          <div className="md:w-[18%] w-[30%]">
                            {
                              data.status == 4 || data.feerate == data.boostFeerate ? 
                              <button className="bg-gray-800 rounded-md py-[6px] px-4" >{t('BOOSTED')}</button>
                              :
                              <button className="bg-primary hover:bg-primary-hover rounded-md py-[6px] px-4" onClick={() => {setBoostData(data); setShowBoostFeeRate(true)}}>{t('BOOST')}</button>
                            }
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
                :
                <></>
              }
            </div>
          </div>
          :
          <></>
        }
      </div>
      <Dialog
        open={showBoostFeeRate}
        size={"xs"}
        className="bg-background2"
      >
        <DialogHeader>
          <div className="flex flex-row w-full justify-center mt-6 sm:text-[32px] text-[24px] font-bold text-primary">
            {t('Boost Fee Rate')}
          </div>
        </DialogHeader>
        <DialogBody>
          <div className={`flex flex-col gap-3 w-full`}>
            <div className="text-white font-bold">
              {t('Maximum boost fee rate')}: {boostData.boostFeerate}
            </div>
            <div>
              <Input type="text" color="white" label = {t('Boost Fee Rate')} className="w-full md:min-w-[400px] min-w-[250px]" value={boostFeeRate} onChange = {(e) => {setBoostFeeRate(e.target.value)}}/>
            </div>
            <div className="grid grid-cols-2 gap-3 w-full">
              <button className="bg-primary hover:bg-primary-hover rounded-md py-[6px] px-4 text-white font-bold" onClick={() => {handleBoost(boostData)}}>{t('Boost')}</button>
              <button className="bg-gray-800 hover:bg-gray-700 rounded-md py-[6px] px-4 text-white font-bold" onClick={() => {setShowBoostFeeRate(false)}}>{t('Cancel')}</button>
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </div>
  )
}
